
<div [ngClass]="[formConfig?.hideCard ? 'form-horizontal col-lg-12':'form-horizontal col-lg-12 card']">
  <ng-content select="form-body"></ng-content>
  <app-jt-actions-modal [hideDefaultAction]='formConfig?.hideDefaultAction' (bySave)="Save()" (byCancel)="Cancel()">
    <action-extender>
      <ng-content select="form-actions">

      </ng-content>
    </action-extender>
  </app-jt-actions-modal>
</div>


